import { Record } from 'immutable';
import { findIndex } from 'underscore';

const {
    GET_AGENCIES_REQUEST,
    GET_AGENCIES_SUCCESS,
    GET_AGENCIES_FAILURE,

} = require('./agencyActions').constants;

const InitialState = Record({
    error: null,
    isFetching: false,
    agencies: []
});

const initialState = new InitialState();

/**
 * ## galleryReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
export default function userReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

    switch (type) {
    case GET_AGENCIES_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);


    case GET_AGENCIES_SUCCESS: {
        return state.set('isFetching', false)
            .set('agencies', payload.data);
    }

    case GET_AGENCIES_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    default:
        return state;
    }
}
